
/// <amd-module name="Search/Shared/Components/ZeroData/ZeroDataUtils" />
import * as React from "react";
import * as Resources from "Search/Shared/Resources";
import { format } from "VSS/Core/Util/String";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Link } from "VSSUI/Link";

export function getZeroResultsHelpComponent(
    isHosted: boolean,
    helpText: string,
    learnMoreFormat: string,
    learnMoreLink: string,
    learnMoreLinkAriaLabel: string,
    feedbackMailLink: string,
    onFeedbackMailLinkClick: () => void
): JSX.Element {
    return (
        <div>
            <div>{helpText}</div>
            <div className="learn-more">
                <FormatComponent format={learnMoreFormat}>
                    {
                        <Link
                            className="help-link-message"
                            target="_blank"
                            rel="noopener noreferrer"
                            ariaLabel={learnMoreLinkAriaLabel}
                            href={learnMoreLink}>
                            <u>{Resources.LearnMoreLabel}</u>
                        </Link>
                    }
                </FormatComponent>
            </div>
            <div>
                {
                    isHosted
                        ? <FormatComponent format={Resources.ZeroResultsContactUsFormat}>
                            {
                                <Link
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={feedbackMailLink}
                                    ariaLabel={Resources.LetUsKnowAriaLabel}
                                    onClick={onFeedbackMailLinkClick}>
                                    <u>{Resources.LetUsKnowLabel}</u>
                                </Link>
                            }
                        </FormatComponent>
                        : format(Resources.ZeroResultsContactUsFormat, Resources.ContactAdmin)
                }
            </div>
        </div>
    );
}

export function getServiceErrorHelp(isHosted: boolean, feedbackMailLink: string): JSX.Element | string {
    const helpText: string = Resources.ServiceErrorHelpText;
    const letUsKnowLabel: string = Resources.LetUsKnowLabel;

    const help: string | JSX.Element = isHosted
        ? <FormatComponent format={helpText}>
            {
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href={feedbackMailLink}>
                    {letUsKnowLabel}
                </Link>
            }
        </FormatComponent>
        : format(helpText, Resources.ContactAdmin);

    return help;
}

export function getIndexingHelp(isHosted: boolean, feedbackMailLink: string): JSX.Element | string {
    const help: string | JSX.Element = isHosted
        ? <FormatComponent format={Resources.AccountIndexingHelpFormat}>
            {
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href={feedbackMailLink}>
                    {Resources.ContactUsLabel}
                </Link>
            }
        </FormatComponent>
        : format(Resources.AccountIndexingHelpFormat, Resources.ContactAdmin);

    return help;
}

export function getAccessPermissionHelp(helpLink?: string): JSX.Element {
    return (
        <FormatComponent format={Resources.ZeroResultsNoPermissionHelpFormat}>
            {
                !!helpLink
                    ? <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        href={helpLink}>
                        {Resources.CheckAccessPermissionLabel}
                    </Link>
                    : Resources.CheckAccessPermissionLabel
            }
        </FormatComponent>);
}

export function getQueryNotSupportedHelp(queryText: string, formatText: string): JSX.Element {
    return (
        <FormatComponent format={formatText}>
            {
                <span className="searchText">
                    {queryText}
                </span>
            }
        </FormatComponent>);
}